import React from 'react';

interface FlyoutProps {
  children?: React.ReactNode[],
  id?: string;
  title: string;
  handleCloseFlyout: any;
}

export default class Flyout extends React.Component<FlyoutProps, any> {
  static defaultProps = {
    children: null,
    id: '',
  }

  render() {
    return (
      <div id={this.props.id} className="flyout">
        <div className="inner">
          <div className="inner-container">
            {this.renderCloseButton()}
            <h2>{this.props.title}</h2>
          </div>
          {this.props.children}
        </div>
        <div className="body-overlay" onClick={this.props.handleCloseFlyout} />
      </div>
    );
  }

  renderCloseButton = () => {
    return (
      <a className="close-flyout" onClick={this.props.handleCloseFlyout} href="#">
        <i className="fa fa-times" />
      </a>
    );
  }
}
